/* Download export file via axios */
import axios from "axios";

window.exportFile = function(url, filterParams) {
  let dialog = bootbox.dialog({
    message: '<p class="text-left mb-0"><i class="fa fa-spinner"></i> Processing export, please wait ...</p>',
    closeButton: false
  });

  axios({
    url: url,
    method: 'GET',
    params: filterParams,
    responseType: 'blob'
  }).then(response => {
    const href = URL.createObjectURL(new Blob([response.data])),
     link = document.createElement('a'),
     filename = response.headers['content-disposition'].split('filename=')[1].replace(/"/g, '');

    link.href = href;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click()
    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link)
    URL.revokeObjectURL(href)
    showNotification('success', `Exported to file ${filename} successfully`)
  }).catch(error => {
    showErrorMessage(`Export failed: ${error}`);
  }).finally(() => {
    // It is possible the bootbox dialog is not ready if the server responses too quick,
    // so delay 0.5 second to make sure the dialog is shown be3fore hide it
    setTimeout(function() {
      dialog.modal('hide');
    }, 500);
  })
}
